import React from "react";
import { ArrowUpRight } from "lucide-react";
import { stay } from "../mock";
import useReveal from "../hooks/useReveal";

export default function Stay() {
  const [ref, visible] = useReveal();
  return (
    <section className="py-24 md:py-32 px-6">
      <div
        ref={ref}
        className={`max-w-[1150px] mx-auto grid grid-cols-1 md:grid-cols-2 gap-12 md:gap-20 items-center reveal ${
          visible ? "is-visible" : ""
        }`}
      >
        <div className="img-zoom h-[460px] md:h-[600px] overflow-hidden border-[6px] border-[#F4EFE6] shadow-xl">
          <img src={stay.image} alt="Where to stay" className="w-full h-full object-cover" />
        </div>
        <div>
          <h2 className="font-serif-display text-[#9E2B25] text-[46px] md:text-[64px] leading-none">{stay.title}</h2>
          <p className="mt-8 text-[#4a443d] leading-relaxed max-w-lg">{stay.intro}</p>

          <div className="mt-10 space-y-8">
            {stay.hotels.map((h, i) => (
              <div key={i} className="border-t border-[#211E1A]/15 pt-6">
                <h3 className="text-[13px] uppercase tracking-widest-2 text-[#211E1A] font-semibold">{h.name}</h3>
                <p className="mt-1 text-[#4a443d]">{h.note}</p>
                <a
                  href={h.url}
                  target="_blank"
                  rel="noreferrer"
                  className="mt-3 inline-flex items-center gap-1 text-[#9E2B25] link-underline text-sm"
                >
                  Book now <ArrowUpRight size={15} />
                </a>
              </div>
            ))}
            <div className="border-t border-[#211E1A]/15 pt-6">
              <h3 className="text-[13px] uppercase tracking-widest-2 text-[#211E1A] font-semibold">Other Options</h3>
              <a
                href={stay.otherUrl}
                target="_blank"
                rel="noreferrer"
                className="mt-3 inline-flex items-center gap-1 text-[#9E2B25] link-underline text-sm"
              >
                Find other places to stay <ArrowUpRight size={15} />
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
